import type { RouteRecordRaw } from "vue-router";
import { guardChatAccess } from "@/config/router/navigationsGuards/guardChat";

const MODULE_NAME = "MESSAGING";

const chatRoutes: Array<RouteRecordRaw> = [
  {
    path: "/messaging",
    name: "Messaging",
    component: () => import("@/views/messaging/Messaging.vue"),
    beforeEnter: [guardChatAccess],
    meta: {
      requiresAuth: true,
      navbarNotRequired: false,
      titleTranslationKey: "pageTitle.messaging",
    },
  },
];

export default chatRoutes.map((route) => ({
  ...route,
  meta: { ...route.meta, moduleName: MODULE_NAME },
}));
